/* eslint-disable lodash/import-scope */
/* eslint-disable import/no-named-as-default */
/* eslint-disable import/no-named-as-default-member */

/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import { SearchOutlined } from '@ant-design/icons'
import { Input, TableColumnsType } from 'antd'
import classNames from 'classnames'
import { useTranslation } from 'contexts/Localization'
import React, { useCallback, useMemo, useState } from 'react'
import Table from 'components/Table'

import { get, debounce } from 'lodash'

interface RewardMembersProps<T> {
  className?: string
  data: T[]
  columns: TableColumnsType<T>
  searchNameKey: string[]
  filterRankKey: string
}

const rankFilterOptions = [
  { name: 'Diamond', key: 3 },
  { name: 'Platinum', key: 2 },
  { name: 'Gold', key: 1 },
]

const RewardMembers = <T extends object>({
  className,
  data,
  columns,
  searchNameKey,
  filterRankKey,
}: RewardMembersProps<T>) => {
  const { t } = useTranslation()

  const [rankSelected, setRankSelected] = useState([1, 2, 3])
  const [search, setSearch] = useState('')

  const filteredData = useMemo(() => {
    const regex = new RegExp(search, 'i')

    const filteredBySearch = !search
      ? data
      : data?.filter((item) => searchNameKey?.some((el) => get(item, el, '')?.match(regex)))

    const filteredByRank = filteredBySearch.filter((item) => rankSelected.includes(get(item, filterRankKey, '')))

    return filteredByRank
  }, [search, data, searchNameKey, rankSelected, filterRankKey])

  /**
   * function
   * =================================================================
   */

  const updateSearchValue = debounce((e) => {
    setSearch(e?.target?.value)
  }, 500)

  const onSelectedRankFilter = useCallback((value) => {
    setRankSelected((prev) => {
      const isExist = prev?.includes(value)

      if (isExist) {
        return prev?.filter((item) => item !== value)
      }

      return [...prev, value]
    })
  }, [])

  /**
   * render view
   * =================================================================
   */

  return (
    <div className={classNames('p-5 background border-solid border-2 stroke-brand-alpha-1', className)}>
      <Input
        onChange={updateSearchValue}
        size="large"
        prefix={<SearchOutlined rev={undefined} />}
        placeholder={t('Search')}
      />
      <div className="mt-5 flex flex-col md:flex-row md:justify-between md:items-center  gap-2">
        <div className="flex items-center gap-3">
          {rankFilterOptions?.map((item) => (
            <div
              onClick={() => onSelectedRankFilter(item?.key)}
              key={item?.name}
              className={classNames(
                'flex-1 border-solid border font-bold text-center py-3 px-0 md:px-4',
                rankSelected?.includes(item?.key)
                  ? 'text-link border-brand-500 dark:border-brand-400'
                  : 'border-text-secondary text-text-secondary',
              )}
            >
              <p>{item?.name}</p>
            </div>
          ))}
        </div>
        <p className="text-text-secondary flex items-start gap-1">
          {t('Rank members')}: <span className="text-primary">{filteredData?.length ?? 0}</span>
        </p>
      </div>

      <Table columns={columns} className="mt-10" dataSource={filteredData} />
    </div>
  )
}

export default RewardMembers
